function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var ImageTokenHelper = /*#__PURE__*/function () {
  function ImageTokenHelper() {
    var _this = this;

    _defineProperty(this, "setShouldUseImageToken", function () {
      _this.shouldUseImageToken = true;
    });

    _defineProperty(this, "setToken", function (item) {
      _this.token = item.dto.imageToken || item.dto.token;
    });

    _defineProperty(this, "addToken", function (url) {
      if (_this.token) {
        return url + ("?token=" + _this.token);
      }

      return url;
    });

    this.shouldUseImageToken = false;
    this.token = '';
  }

  _createClass(ImageTokenHelper, [{
    key: "exists",
    get: function get() {
      return !!this.token;
    }
  }]);

  return ImageTokenHelper;
}();

export default new ImageTokenHelper();